// frontend/src/modules/folha/pages/Holerite.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPrint, FaFilePdf } from 'react-icons/fa';
import HoleriteHeader from '../components/HoleriteHeader';
import HoleriteFooter from '../components/HoleriteFooter';
import HoleriteDetalhes from '../components/HoleriteDetalhes';

function Holerite() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [holerite, setHolerite] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const token = localStorage.getItem('token');

  const fetchHolerite = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/holerite/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar holerite');
      const data = await response.json();
      setHolerite(data);
      
      // Buscar dados da empresa
      if (data.empresa_id) {
        const empresaResponse = await fetch(`/api/empresas/${data.empresa_id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (empresaResponse.ok) {
          const empresaData = await empresaResponse.json();
          setEmpresa(empresaData);
        }
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHolerite();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;
  if (error) return <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>❌ {error}</div>;
  if (!holerite) return <div style={{ textAlign: 'center', padding: '50px' }}>Holerite não encontrado</div>;

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      {/* Botões de Ação */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px',
        flexWrap: 'wrap',
        gap: '10px'
      }}>
        <button 
          onClick={() => navigate(-1)} 
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#007bff', 
            cursor: 'pointer', 
            fontSize: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <FaArrowLeft /> Voltar
        </button>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button 
            onClick={handlePrint} 
            style={{ 
              padding: '10px 20px', 
              backgroundColor: '#28a745', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <FaPrint /> Imprimir
          </button>
          <button 
            onClick={() => window.print()} 
            style={{ 
              padding: '10px 20px', 
              backgroundColor: '#dc3545', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <FaFilePdf /> Baixar PDF
          </button>
        </div>
      </div>

      {/* Holerite */}
      <div 
        style={{ 
          backgroundColor: 'white', 
          padding: '30px', 
          borderRadius: '8px', 
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          maxWidth: '900px',
          margin: '0 auto'
        }} 
        id="holerite"
      >
        {/* Cabeçalho */}
        <HoleriteHeader
          empresa={empresa || holerite.empresa}
          funcionario={holerite.funcionario}
          mesReferencia={holerite.mes_referencia}
          anoReferencia={holerite.ano_referencia}
          tipo="holerite"
        />

        {/* Detalhes do Holerite */}
        <HoleriteDetalhes 
          dados={holerite} 
          formatCurrency={formatCurrency}
        />

        {/* Informações Adicionais */}
        {holerite.observacoes && (
          <div style={{
            marginTop: '15px',
            padding: '10px',
            backgroundColor: '#fff3cd',
            borderRadius: '4px',
            fontSize: '13px',
            color: '#856404'
          }}>
            <strong>📝 Observações:</strong> {holerite.observacoes}
          </div>
        )}

        {/* Rodapé */}
        <HoleriteFooter
          empresa={empresa || holerite.empresa}
          dataPagamento={formatDate(holerite.data_pagamento)}
          status={holerite.status}
        />
      </div>

      {/* CSS para impressão */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #holerite, #holerite * {
              visibility: visible;
            }
            #holerite {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 20px;
              box-shadow: none !important;
            }
            .no-print {
              display: none !important;
            }
            button {
              display: none !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default Holerite;